// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/watcheeBoxStyle.css
// module id = cPqi
// module chunks = 1